export default "/logo-university-mcgill.png";